import * as sonbp from "sonbp";
import * as listener from "../listener";
import * as edidor from "../listener/editor";

/* ============================================================
 * Result
 * ============================================================ */
export interface IResult { code: number, msg?: string, ex?: any };

/* ============================================================
 * IF内共有情報
 * ============================================================ */
export class ifDto {

	// --------------------------------------
	// フロント側の各種制御情報
	// --------------------------------------
	public vue: Vue;

	// --------------------------------------
	// sonbp2本体
	// --------------------------------------
	public bpView: sonbp.view = null;

	/**
	 * 承認用トークン
	 */
	public token: string = null;

	// --------------------------------------
	// 通知
	// --------------------------------------
	public _onChange: (vp: any) => void;
	public _onExchange: (a: { waku: any, img: any }, b: { waku: any, img: any }) => void;

	// 通信エラー
	public _onApiError: (e: any) => boolean;
	public callbackOnApiError(e: any): boolean {

		try {

			let err: any = e;
			if (e.message?.startsWith('api error ')) {
				//hit.
			} else if (e.error?.message?.startsWith('api error ')) {
				err = e.error;
			} else {
				return true;
			}

			if (this._onApiError) {

				let ret = this._onApiError(err);
				if (!ret) {
					this.cleareCollbackError();
				}
				return ret;
			}
		} catch (e) {

			console.error("[sonbpIf-callbackOnApiError] error.", e);
		}
		return true;
	}

	// --------------------------------------
	// エラー通知
	// --------------------------------------
	public _nop_func = function (obj: any): void {
		console?.error(obj);
	};
	public _callback_error: (obj: any) => void;
	public setCallbackError(callback: (obj: any) => void): void {
		let that = this;
		this._callback_error = function (obj) {
			that._callback_error = that._nop_func;
			callback(obj);
		};
	}
	public cleareCollbackError(): void {
		this._callback_error = this._nop_func;
	}
	public callbackError(obj: any): void {
		this._callback_error(obj);
	}

	// --------------------------------------
	// リスナー
	// --------------------------------------
	// 画像読込・配置
	public bpSelector: listener.poscaSelector;
	public bpImageDragger: listener.poscaImageDragger;
	public bpSelectorWithExchange: listener.poscaSelectorWithExchange;
	public bpSelectorWithExchangeSP: listener.poscaSelectorWithExchangeSP;
	public bpFrontDrawer: listener.poscaFrontDrawer;

	/**
	 * 現在アクティブなセレクターを返す
	 */
	public get activeSelector(): listener.poscaSelector {
		let sel = this.bpView.getListener()[0][0];

		if (sel instanceof listener.poscaSelector) {
			return sel as listener.poscaSelector;
		}

		return this.bpSelector;
	}

	// --------------------------------------
	// ムーバー
	// --------------------------------------
	public bpClipImageEditor: edidor.poscaClipImageEditor;
	public bpStampEditor: sonbp.listener.editor.moveEditor;
	public bpTextEditor: sonbp.listener.editor.moveEditor;

	// --------------------------------------
	// 現在のview状態
	// --------------------------------------

	/**
	 * 端末モード（PC or SP）
	 */
	public client: string;

	/**
	 * 処理モード
	 */
	public procMode: string;

	/**
	 * 仕上がり区分（1 or 2）
	 */
	public areaType: string;

	/**
	 * ページ表示エリアサイズ
	 */
	public pageAreaSize?: number;

	/**
	 * 文字の稼働範囲（pt）
	 */
	public txtRange: {
		w: number,
		h: number
	} = null;

	/**
	 * 文字の稼働範囲（pt）
	 */
	public txtRangeStamp: {
		w: number,
		h: number,
	} = null;

	/**
	 * ページ描画のオフセット位置（pt）
	 */
	public pageOffset: {
		x: number,
		y: number
	} = null;

	// --------------------------------------
	// キャッシュ系
	// --------------------------------------

	/**
	 * file_key - resource_key のマッピングキャッシュ
	 */
	public fileKeyCache: ImageResourceModel[];

	/**
	 * 通常表示時の表示拡大率（SPの画像編集時以外での拡大率）
	 */
	public normalScale = {
		normalScaleRate: 1.0,
		normalDrawPoint: new sonbp.type.point(0, 0)
	};
}

export class ImageResourceModel {
	public UniqueId: string;
	public FileKey: string;
	public ResourceKey: string;
	public Subtype: string;
	public Width: number;
	public Height: number;
	//
	public FileId: string;
	public orgWidth: number;
	public orgHeight: number;
};
